import type { Point } from "@pdfking/math"
import type { Distance } from "@pdfking/math"
import { DrawPath, PlotFunction } from "@pdfking/renderer-api"
import type { PageShape } from "@pdfking/renderer-api"
import type { GrowTemplate } from "@pdfking/templates"

import type { GrowPlotter, PlotContribute } from "#internal"
import { CUT_LAYER_ID, FOLD_LAYER_ID } from "#internal"

import { GrowDie } from "./GrowDie"
import { ResolveGrow } from "./ResolveGrow"

/** The die-lines of a grow as its tree says them ({@link GrowDie}), drawn
 * at the page as it opens at the side: the cut round its pieces, closed, and
 * a fold along each crease. */
export const PlotGrowDie =
  (template: GrowTemplate): GrowPlotter =>
  size => {
    const die = GrowDie(ResolveGrow(template.layout, size, false))
    const path = (points: Point<Distance>[], layer: string, closed: boolean) =>
      ({
        enum: PlotFunction.PLOT_PATH,
        points: DrawPath([...points]),
        stroke_color: layer,
        ...(closed ? { closed: true } : {}),
      }) as PageShape
    return {
      [CUT_LAYER_ID]: die.cut.map(loop => path(loop, "cut", true)),
      [FOLD_LAYER_ID]: die.fold.map(segment => path(segment, "fold", false)),
    } as PlotContribute
  }
